import './ReportNotReady.scss';

// Показывается вместо /500/ на HTML-страницах отчётов, когда данные отчёта
// ещё не готовы или бэкенд вернул ошибку (например, отчёт не сформирован).
export const ReportNotReady: React.FC<{}> = () => (
  <div className='reportNotReady' data-cy='reportNotReady'>
    Отчёт ещё не сформирован или недоступен
  </div>
);
